import { render, staticRenderFns } from "./ThuxGenericComponentFilterMixin.vue?vue&type=template&id=77345026&"
import script from "./ThuxGenericComponentFilterMixin.vue?vue&type=script&lang=js&"
export * from "./ThuxGenericComponentFilterMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports